export default "__VITE_ASSET__DHYIkWvU__"